const option_enabled = [
  { label: "啟用", value: 1 },
  { label: "停用", value: 0 },
];

const option_time_period = [
  { label: "早上", value: 1 },
  { label: "下午", value: 2 },
  { label: "晚上", value: 3 },
  { label: "全時段", value: 4 },
];

const option_day_period = [
  { label: "日", value: 1 },
  { label: "月", value: 2 },
  { label: "年", value: 3 },
];

const option_daytime_period = [
  { label: "日", value: 1 },
  { label: "月", value: 2 },
  { label: "年", value: 3 },
  { label: "時", value: 4 },
  { label: "分", value: 5 },
];

const option_floor = [
  {
    label: "培英",
    value: 1,
    child: [
      { label: "1F", value: "1F" },
      { label: "2F", value: "2F" },
      { label: "3F", value: "3F" },
      { label: "4F", value: "4F" },
      { label: "5F", value: "5F" },
      { label: "6F", value: "6F" },
      { label: "7F", value: "7F" },
    ],
  },
];

const option_demand_rule = [
  { label: "小時定額", value: "hourly" },
  { label: "日定額", value: "daily" },
  { label: "月定額", value: "monthly" },
  { label: "年定額", value: "yearly" },
];

const option_month = Array.from({ length: 12 }, (_, i) => ({
  label: String(i + 1).padStart(2, "0"),
  value: String(i + 1).padStart(2, "0"),
}));

const option_colors = [
  "#EE8434",
  "#C95D63",
  "#717EC3",
  "#AE8799",
  "#5B618A",
  "#75abc7",
  "#C492B1",
  "#21FA90",
  "#E9D758",
  "#297373",
  "#FF8552",
  "#E6E6E6",
  "#F7D08A",
  "#E3F09B",
  "#87B6A7",
  "#F79F79",
  "#5B5941",
  "#5B507A",
  "#496DDB",
];

export {
  option_enabled,
  option_time_period,
  option_day_period,
  option_daytime_period,
  option_floor,
  option_demand_rule,
  option_month,
  option_colors,
};
